export enum WorkflowSummary {
  Approved = 'Approved',
  Declined = 'Declined',
  NotStarted = 'Not Started',
  Paused = 'Paused',
  PendingApproval = 'Approval Pending',
  PendingTasks = 'Tasks Pending',
  TasksComplete = 'All Tasks Complete',
}
